// extracted by mini-css-extract-plugin
export default {"wrapper":"SliderWapper_wrapper__ANDlJ","left":"SliderWapper_left__8Ijf6","right":"SliderWapper_right__R8Fkn"};